import { BaseSensor } from './BaseSensor';
import { Helper } from './Helper';
import { MenuNode } from './MenuNode';
export class Programs {



	static temporaryStartup(t: any) {
		t.menuService.disableButton('power');
	}


	static chimneySweepStart: number;
	static chimneySweepDynamicRuns = 0;
	static chimneySweepState = 'stopped';
	static chimneySweepDynamic(t: any) {
		Programs.chimneySweepDynamicRuns++;
		console.log("Program running: " + Programs.chimneySweepDynamicRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if (Programs.chimneySweepState == 'stopped') {
			Programs.chimneySweepState = 'running';
			let date = new Date();
			Programs.chimneySweepStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			this.value = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			this.unit = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();
			this.showIconBar = true;
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.chimneySweepStart;
				this.dashIcon = 'iconChimneySweep';
				this.title = this.translator.tr('DELIGHT_MAIN_MENU_ENTRY_CHIMNEY_SWEEPER');
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.chimneySweepState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.chimneySweepStart;
				Programs.chimneySweepStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.chimneySweepState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static automaticWaterFillStart: number;
	static automaticWaterFillRuns = 0;
	static automaticWaterFillState = 'stopped';
	static automaticWaterFill(t: any) {
		Programs.automaticWaterFillRuns++;
		console.log("Program running: " + Programs.automaticWaterFillRuns);
		let getTitle = t.getSubtitle;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		if (Programs.automaticWaterFillState == 'stopped') {
			Programs.automaticWaterFillState = 'running';
			let date = new Date();
			Programs.automaticWaterFillStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {


			this.dashIcon = '';

			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.automaticWaterFillStart;
			/*
			if(diff < duration ){
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
			}
			*/
			if (diff < 3000) {
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');//+"...";
			}

			if (diff > 3000 && diff < duration - 6000) {
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			}

			if (diff >= duration - 6000 && diff < duration - 3000) { // && (diff-1000) <= (duration)){
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');//+"...";
			}
			if (diff > duration - 3000 && diff < duration) {
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
			}

			if (diff > duration) {
				Programs.automaticWaterFillState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				eH.call(t, 'confirm');
			}

			return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');//+"...";
		}
		t.eventHandler = function (evt) {
			console.debug("automaticWaterFill " + evt);
			if (evt === 'question') {
				return;
			}
			if (evt === 'confirm') {
				let now = new Date();
				let diff = parseInt("" + now.getTime()) - Programs.automaticWaterFillStart;
				if (diff > 15 * 60 * 1000 - 6000) {
					return;
				}
				Programs.automaticWaterFillStart = now.getTime() - 15 * 60 * 1000 + 6000;
				setTimeout(() => {
					this.menuService.goto(this.node.getTargetNode());
				}, 6000);
				if (Programs.automaticWaterFillState == 'stopped') {
					this.menuService.goto(this.node.getTargetNode());
				}
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.automaticWaterFillStart;
				Programs.automaticWaterFillStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.automaticWaterFillState = 'stopped';
						console.debug("automaticWaterFill: back triggered on original handler.");
						eH.call(t, 'back');
					},
					1500
				);
				return;
			} else {
				eH.call(t, evt);
			}
		}
	}



	static automaticBrineFillStart: number;
	static automaticBrineFillRuns = 0;
	static automaticBrineFillState = 'stopped';
	static automaticBrineFill(t: any) {
		Programs.automaticBrineFillRuns++;
		console.log("Program running: " + Programs.automaticBrineFillRuns);
		let getTitle = t.getSubtitle;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		if (Programs.automaticBrineFillState == 'stopped') {
			Programs.automaticBrineFillState = 'running';
			let date = new Date();
			Programs.automaticBrineFillStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {


			this.dashIcon = '';

			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.automaticBrineFillStart;
			/*
			if(diff < duration ){
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
			}
			*/
			if (diff < 3000) {
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');//+"...";
			}

			if (diff > 3000 && diff < duration - 6000) {
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			}

			if (diff >= duration - 6000 && diff < duration - 3000) { // && (diff-1000) <= (duration)){
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');//+"...";
			}
			if (diff > duration - 3000 && diff < duration) {
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
			}

			if (diff > duration) {
				Programs.automaticBrineFillState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
			}
			return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');//+"...";
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				return;
			}
			if (evt === 'confirm') {
				let now = new Date();
				let diff = parseInt("" + now.getTime()) - Programs.automaticBrineFillStart;
				if (diff > 15 * 60 * 1000 - 6000) {
					return;
				}
				Programs.automaticBrineFillStart = now.getTime() - 15 * 60 * 1000 + 6000;
				setTimeout(() => {
					this.menuService.goto(this.node.getTargetNode());
				}, 6000);
				if (Programs.automaticBrineFillState == 'stopped') {
					this.menuService.goto(this.node.getTargetNode());
				}
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.automaticBrineFillStart;
				Programs.automaticBrineFillStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.automaticBrineFillState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);

			} else {
				eH.call(t, evt);
			}
		}
	}



	static chimneySweepMaxDHWStart: number;
	static chimneySweepMaxDHWRuns = 0;
	static chimneySweepMaxDHWState = 'stopped';
	static chimneySweeepMaxDHW(t: any) {
		Programs.chimneySweepMaxDHWRuns++;
		console.log("Program running: " + Programs.chimneySweepMaxDHWRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if (Programs.chimneySweepMaxDHWState == 'stopped') {
			Programs.chimneySweepMaxDHWState = 'running';
			let date = new Date();
			Programs.chimneySweepMaxDHWStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		//let scale = t.ioService.deviceInfo().getScale('d077');
		//let d77Val = scale.getCurrentValue();
		//let max = scale.getMaxValue();
		//scale.setCurrentValue(max);


		t.getText = function (idx: number) {
			this.showIconBar = true;
			this.value = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			this.unit = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();

			this.title = this.translator.tr('DELIGHT_CHIMNEY_MENU_TITLE');
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.chimneySweepMaxDHWStart;
				this.dashIcon = 'iconChimneySweep';
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.chimneySweepMaxDHWState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.chimneySweepMaxDHWStart;
				Programs.chimneySweepMaxDHWStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.chimneySweepState = 'stopped';
						eH.call(t, 'back');
						//scale.setCurrentValue(d77Val);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static CompressorHeatingProgramStart: number;
	static CompressorHeatingProgramRuns = 0;
	static CompressorHeatingProgramState = 'stopped';
	static CompressorHeatingProgram(t: any) {
		Programs.CompressorHeatingProgramRuns++;
		console.log("Program running: " + Programs.CompressorHeatingProgramRuns);
		const manual_changes: boolean = true;
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.CompressorHeatingProgramState == 'stopped') {
			Programs.CompressorHeatingProgramState = 'running';
			let date = new Date();
			Programs.CompressorHeatingProgramStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.04 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_COMPRESSOR_HEATING_MODE_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_COMPRESSOR_HEATING_MODE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.CompressorHeatingProgramStart;
				this.unit = this.translator.tr("AICI_UNIT_CELSIUS");
				this.value = "25.0";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.CompressorHeatingProgramState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'confirm' && Programs.CompressorHeatingProgramState !== 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.CompressorHeatingProgramStart;
				Programs.CompressorHeatingProgramStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.CompressorHeatingProgramState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static actuatortest_t01Start: number;
	static actuatortest_t01Runs = 0;
	static actuatortest_t01State = 'stopped';

	static actuatortest_t01(t: any) {
		Programs.actuatortest_t01Runs++;
		console.log("Program running: " + Programs.actuatortest_t01Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		let scale = t.ioService.getDeviceInfo().getScale('d367');
		if (Programs.actuatortest_t01State == 'stopped') {

			scale.setCurrentValue(3);
			Programs.actuatortest_t01State = 'running';
			let date = new Date();
			Programs.actuatortest_t01Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;

		t.getText = function (idx: number) {
			t.title = 'T.01 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';

			this.value = scale.getCurrentValue();

			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t01Start;
				this.unit = this.translator.tr("AICI_UNIT_PERCENT");
				this.value = scale.getCurrentValue()?.toString();

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t01State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt == 'up' || evt == 'down') {
				console.log(evt);
				let scale = this.ioService.getDeviceInfo().getScale('d367');
				if (evt == 'up') {
					scale.setCurrentValue(scale.getCurrentValue() + 1);
				} else {
					scale.setCurrentValue(scale.getCurrentValue() - 1);
				}
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t01Start;
				Programs.actuatortest_t01Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t01State = 'stopped';
						let scale = this.ioService.getDeviceInfo().getScale('d367');
						scale.setCurrentValue(54.0);
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_t02Start: number;
	static actuatortest_t02Runs = 0;
	static actuatortest_t02State = 'stopped';
	static acutatortest_t02Sensor = new BaseSensor().setList(['AICI_TWV_POSITION_CH', 'AICI_TWV_POSITION_DHW', 'AICI_TWV_POSITION_MIDDLE']);

	static actuatortest_t02(t: any) {
		Programs.actuatortest_t02Runs++;
		console.log("Program running: " + Programs.actuatortest_t02Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t02State == 'stopped') {
			Programs.actuatortest_t02State = 'running';
			Programs.acutatortest_t02Sensor.setCurrentValue(0);
			let date = new Date();
			Programs.actuatortest_t02Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.02 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_THREE_WAY_VALVE_DESCRIPTION');


			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.translator.tr(Programs.acutatortest_t02Sensor.getCurrentElement());
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_THREE_WAY_VALVE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t02Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t02State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.actuatortest_t02State != 'stopped') {
				return;
			}
			if (evt === 'up') {
				Programs.acutatortest_t02Sensor.previous(true);
				console.log({ msg: "sensor now: " + Programs.acutatortest_t02Sensor.getCurrentElement(), list: Programs.acutatortest_t02Sensor.list });
			}
			if (evt === 'down') {
				Programs.acutatortest_t02Sensor.next(true);
				console.log({ msg: "sensor now: " + Programs.acutatortest_t02Sensor.getCurrentElement(), list: Programs.acutatortest_t02Sensor.list });
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t02Start;
				Programs.actuatortest_t02Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t02State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static actuatortest_t17Start: number;
	static actuatortest_t17Runs = 0;
	static actuatortest_t17State = 'stopped';
	static fan1_sensor = BaseSensor.fromArgs('fan1', 1, 1, 100, 1, 'AICI_UNIT_PERCENT');
	static actuatortest_t17(t: any) {
		Programs.actuatortest_t17Runs++;
		console.log("Program running: " + Programs.actuatortest_t17Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t17State == 'stopped') {
			Programs.fan1_sensor.setCurrentValue(1);
			Programs.actuatortest_t17State = 'running';
			let date = new Date();
			Programs.actuatortest_t17Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.17 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_1_DESCRIPTION');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = Programs.fan1_sensor.getCurrentValue();
			if (idx == 0) {
				//return this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_1_SUBLINE_1');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t17Start;
				this.unit = this.translator.tr("AICI_UNIT_PERCENT");
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t17State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.actuatortest_t17State != 'stopped') {
				return;
			}
			if (evt === 'up') {
				Programs.fan1_sensor.next(false);
			}
			if (evt === 'down') {
				Programs.fan1_sensor.previous(false);
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t17Start;
				Programs.actuatortest_t17Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t17State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_t18Start: number;
	static actuatortest_t18Runs = 0;
	static actuatortest_t18State = 'stopped';
	static actuatortest_t18(t: any) {
		Programs.actuatortest_t18Runs++;
		console.log("Program running: " + Programs.actuatortest_t18Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t18State == 'stopped') {
			Programs.actuatortest_t18State = 'running';
			let date = new Date();
			Programs.actuatortest_t18Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.18 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_2');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_2_SUBLINE_1');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t18Start;
				this.unit = this.translator.tr("AICI_UNIT_PERCENT");
				this.value = "1";
				if (diff > 1500) {
					this.value = "1";
				}
				if (diff > 2500) {
					this.value = "3";
				}
				if (diff > 4000) {
					this.value = "3";
				}
				if (diff > 6000) {
					this.value = "4";
				}
				if (diff > 55000) {
					this.value = "5";
				}

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t18State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.actuatortest_t18State != 'stopped') {
				return;
			}

			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t18Start;
				Programs.actuatortest_t18Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t18State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}






	static actuatortest_t19Start: number;
	static actuatortest_t19Runs = 0;
	static actuatortest_t19State = 'stopped';
	static condensate_tray_heater = (new BaseSensor()).setList(['AICI_ON_NORMAL', 'AICI_OFF_NORMAL'])
	static actuatortest_t19(t: any) {
		Programs.actuatortest_t19Runs++;
		console.log("Program running: " + Programs.actuatortest_t19Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t19State == 'stopped') {
			Programs.actuatortest_t19State = 'running';
			Programs.condensate_tray_heater.setCurrentValue(0);
			let date = new Date();
			Programs.actuatortest_t19Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.19 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_CONDENSATE_TRAY_HEATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_CONDENSATE_TRAY_HEATER_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t19Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');
				this.value = this.translator.tr(Programs.condensate_tray_heater.getCurrentElement());

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					Programs.condensate_tray_heater.setCurrentValue(1);
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t19State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_t19State != 'stopped') {
				return;
			}
			/*
			if (evt === 'up') {
				Programs.condensate_tray_heater.next(true);
			}
			if (evt === 'down') {
				Programs.condensate_tray_heater.previous(true);
			}*/
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t19Start;
				Programs.actuatortest_t19Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t19State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_t127Start: number;
	static actuatortest_t127Runs = 0;
	static actuatortest_t127State = 'stopped';
	static actuatortest_t127(t: any) {
		Programs.actuatortest_t127Runs++;
		console.log("Program running: " + Programs.actuatortest_t127Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t127State == 'stopped') {
			Programs.actuatortest_t127State = 'running';
			let date = new Date();
			Programs.actuatortest_t127Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.127 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_BACKUP_HEATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_BACKUP_HEATER_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t127Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');
				this.value = this.translator.tr('AICI_OFF_NORMAL');
				if (diff > 3500) {
					this.value = this.translator.tr('AICI_ON_NORMAL');
				}
				if (diff > 8000) {
					this.value = this.translator.tr('AICI_OFF_NORMAL');

				}
				if (diff > 55000) {
					this.value = this.translator.tr('AICI_ON_NORMAL');
				}

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t127State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t127Start;
				Programs.actuatortest_t127Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t127State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static actuatortest_t22Start: number;
	static actuatortest_t22Runs = 0;
	static actuatortest_t22State = 'stopped';
	static actuatortest_t22(t: any) {
		Programs.actuatortest_t22Runs++;
		console.log("Program running: " + Programs.actuatortest_t22Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t22State == 'stopped') {
			Programs.actuatortest_t22State = 'running';
			Programs.fan1_sensor.setCurrentValue(1);
			let date = new Date();
			Programs.actuatortest_t22Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.22 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_ELECTRONIC_EXPANSION_VALVE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = Programs.fan1_sensor.getCurrentValue();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_ELECTRONIC_EXPANSION_VALVE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t22Start;
				this.unit = this.translator.tr("AICI_UNIT_PERCENT");


				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t22State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'up') {
				Programs.fan1_sensor.next(false);
			}
			if (evt === 'down') {
				Programs.fan1_sensor.previous(false);
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t22Start;
				Programs.actuatortest_t22Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t18State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static actuatortest_t23Start: number;
	static actuatortest_t23Runs = 0;
	static actuatortest_t23State = 'stopped';
	static actuatortest_t23(t: any) {
		Programs.actuatortest_t23Runs++;
		console.log("Program running: " + Programs.actuatortest_t23Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t23State == 'stopped') {
			Programs.condensate_tray_heater.setCurrentValue(0);
			Programs.actuatortest_t23State = 'running';
			let date = new Date();
			Programs.actuatortest_t23Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.23 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_CRANK_CASE_HEATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.translator.tr(Programs.condensate_tray_heater.getCurrentElement());
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_CRANK_CASE_HEATER_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t23Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					Programs.condensate_tray_heater.setCurrentValue(1);
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t23State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_t23State != 'stopped') {
				return;
			}
			/*
			if (evt === 'up') {
				Programs.condensate_tray_heater.next(true);
			}
			if (evt === 'down') {
				Programs.condensate_tray_heater.previous(true);
			}*/
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t23Start;
				Programs.actuatortest_t23Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t23State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_t119Start: number;
	static actuatortest_t119Runs = 0;
	static actuatortest_t119State = 'stopped';
	static actuatortest_t119(t: any) {
		Programs.actuatortest_t119Runs++;
		console.log("Program running: " + Programs.actuatortest_t119Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t119State == 'stopped') {
			Programs.actuatortest_t119State = 'running';
			Programs.condensate_tray_heater.setCurrentValue(0);
			let date = new Date();
			Programs.actuatortest_t119Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.119 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_MULTI_PURPOSE_OUTPUT_1');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.translator.tr(Programs.condensate_tray_heater.getCurrentElement());
			if (idx == 0) {
				//return this.translator.tr('DELIGHT_ACTUATOR_TEST_MULTI_PURPOSE_OUTPUT_1_SUBLINE_1');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t119Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t119State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_t119State != 'stopped') {
				return;
			}
			/*
			if (evt === 'up') {
				Programs.condensate_tray_heater.next(true);
			}
			if (evt === 'down') {
				Programs.condensate_tray_heater.previous(true);
			}*/
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t119Start;
				Programs.actuatortest_t119Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t119State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_t126Start: number;
	static actuatortest_t126Runs = 0;
	static actuatortest_t126State = 'stopped';
	static actuatortest_t126(t: any) {
		Programs.actuatortest_t126Runs++;
		console.log("Program running: " + Programs.actuatortest_t126Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t126State == 'stopped') {
			Programs.actuatortest_t126State = 'running';
			Programs.condensate_tray_heater.setCurrentValue(0);
			let date = new Date();
			Programs.actuatortest_t126Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.126 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_MULTI_PURPOSE_OUTPUT_1');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.translator.tr(Programs.condensate_tray_heater.getCurrentElement());
			if (idx == 0) {
				//return this.translator.tr('DELIGHT_ACTUATOR_TEST_MULTI_PURPOSE_OUTPUT_1_SUBLINE_1');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t126Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					Programs.condensate_tray_heater.setCurrentValue(1);
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t126State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.actuatortest_t126State != 'stopped') {
				return;
			}
			/*
			if (evt === 'up') {
				Programs.condensate_tray_heater.next(true);
			}
			if (evt === 'down') {
				Programs.condensate_tray_heater.previous(true);
			}*/
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t126Start;
				Programs.actuatortest_t126Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t126State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}





	static actuatortest_t21Start: number;
	static actuatortest_t21Runs = 0;
	static actuatortest_t21State = 'stopped';
	static actuatortest_t21(t: any) {
		Programs.actuatortest_t21Runs++;
		console.log("Program running: " + Programs.actuatortest_t21Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t21State == 'stopped') {
			Programs.actuatortest_t21State = 'running';
			let date = new Date();
			Programs.fan1_sensor.setCurrentValue(1);
			Programs.actuatortest_t21Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.21 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_ELECTRONIC_EXPANSION_VALVE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = Programs.fan1_sensor.getCurrentValue();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_ELECTRONIC_EXPANSION_VALVE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t21Start;
				this.unit = this.translator.tr("AICI_UNIT_PERCENT");


				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t21State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'up') {
				Programs.fan1_sensor.next(false);
			}
			if (evt === 'down') {
				Programs.fan1_sensor.previous(false);
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t21Start;
				Programs.actuatortest_t21Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t21State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}






	static actuatortest_t118Start: number;
	static actuatortest_t118Runs = 0;
	static actuatortest_t118State = 'stopped';
	static actuatortest_t118(t: any) {
		Programs.actuatortest_t118Runs++;
		console.log("Program running: " + Programs.actuatortest_t118Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_t118State == 'stopped') {
			Programs.actuatortest_t118State = 'running';
			Programs.condensate_tray_heater.setCurrentValue(0);
			let date = new Date();
			Programs.actuatortest_t118Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.06 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_BACKUP_HEATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.translator.tr(Programs.condensate_tray_heater.getCurrentElement());
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_BACKUP_HEATER_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_t118Start;
				this.unit = "";//this.translator.tr('AICI_UNIT_PERCENT');
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					Programs.condensate_tray_heater.setCurrentValue(1);
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.actuatortest_t118State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			/*
			if (evt === 'up') {
				Programs.condensate_tray_heater.next(true);
			}
			if (evt === 'down') {
				Programs.condensate_tray_heater.previous(true);
			}*/
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_t118Start;
				Programs.actuatortest_t118Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_t118State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static pruefprogramm_kühlStart: number;
	static pruefprogramm_kühlRuns = 0;
	static pruefprogramm_kühlState = 'stopped';
	static pruefprogramm_kühl(t: any) {
		Programs.pruefprogramm_kühlRuns++;
		console.log("Program running: " + Programs.pruefprogramm_kühlRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_kühlState == 'stopped') {
			Programs.pruefprogramm_kühlState = 'running';
			let date = new Date();
			Programs.pruefprogramm_kühlStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.11 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_COOLING_MODE_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_COOLING_CONFIG_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_kühlStart;
				this.unit = this.translator.tr("AICI_UNIT_CELSIUS");
				this.value = "20.0";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_kühlState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'confirm' && Programs.pruefprogramm_kühlState != 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_kühlStart;
				Programs.pruefprogramm_kühlStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_kühlState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static pruefprogramm_electroheatingStart: number;
	static pruefprogramm_electroheatingRuns = 0;
	static pruefprogramm_electroheatingState = 'stopped';
	static pruefprogramm_electroheating(t: any) {
		Programs.pruefprogramm_electroheatingRuns++;
		console.log("Program running: " + Programs.pruefprogramm_electroheatingRuns);
		let getText = t.getText;

		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_electroheatingState == 'stopped') {
			Programs.pruefprogramm_electroheatingState = 'running';
			let date = new Date();
			Programs.pruefprogramm_electroheatingStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.27 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_IMMERSION_HEATER_HEATING_MODE_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_COOLING_CONFIG_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_electroheatingStart;
				this.unit = this.translator.tr("AICI_UNIT_CELSIUS");
				this.value = "30.0";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_electroheatingState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'confirm' && Programs.pruefprogramm_electroheatingState != 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_electroheatingStart;
				Programs.pruefprogramm_electroheatingStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_electroheatingState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static pruefprogramm_hochdruckStart: number;
	static pruefprogramm_hochdruckRuns = 0;
	static pruefprogramm_hochdruckState = 'stopped';
	static pruefprogramm_hochdruck(t: any) {
		Programs.pruefprogramm_hochdruckRuns++;
		console.log("Program running: " + Programs.pruefprogramm_hochdruckRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_hochdruckState == 'stopped') {
			Programs.pruefprogramm_hochdruckState = 'running';
			let date = new Date();
			Programs.pruefprogramm_hochdruckStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.29 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_HIGH_PRESSURE_TEST_TITLE');
			this.showIconBar = true;
			this.value = "16.5";
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_hochdruckStart;
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_HIGH_PRESSURE_TEST_DESCRIPTION') + ' ' + '64 °C';
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {
				this.unit = this.translator.tr("AICI_UNIT_CELSIUS");


				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_hochdruckState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'confirm' && Programs.pruefprogramm_hochdruckState !== 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_hochdruckStart;
				Programs.pruefprogramm_hochdruckStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_hochdruckState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static riseValueOvertime(duration: number, from: number, to: number, formatter?: ((number) => any)): CallableFunction {
		let start = new Date().getTime();
		/**
		 * start = 100
		 * duration = 10
		 * 
		 * end = 110
		 * end - start  =  10
		 * 
		 * current = 103
		 * current - start = 3
		 * 
		 */
		let end = start + duration;
		return () => {
			let current = new Date().getTime();
			let pos = (current - start) / (end - start)
			if (current < start) {
				return from;
			}
			if (current > end) {
				return to;
			}
			let numericValue = from + (pos * (to - from));
			if (formatter) {
				return formatter(numericValue);
			}

		}
	}



	static pruefprogramm_gebkr_fill_waterStart: number;
	static pruefprogramm_gebkr_fill_waterRuns = 0;
	static pruefprogramm_gebkr_fill_waterState = 'stopped';
	static pruefprogramm_gebkr_fill_water(t: any) {
		Programs.pruefprogramm_gebkr_fill_waterRuns++;
		console.log("Program running: " + Programs.pruefprogramm_gebkr_fill_waterRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_gebkr_fill_waterState == 'stopped') {
			Programs.pruefprogramm_gebkr_fill_waterState = 'running';
			let date = new Date();
			Programs.pruefprogramm_gebkr_fill_waterStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		let valueWalker = Programs.riseValueOvertime(30 * 1000, 0, 1.5, (n: number) => n.toFixed(1));
		t.getText = function (idx: number) {
			this.value = valueWalker()
			t.title = 'P.30 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER_BUILDING_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_gebkr_fill_waterStart;
			if (idx == 0) {
				return "";
				return this.translator.tr('DELIGHT_TEST_PROGRAM_IMMERSION_HEATER_HEATING_MODE_TITLE_SUBLINE_1') + ((diff < 1000) ? '0' : '50');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {



				this.unit = this.translator.tr("AICI_UNIT_BAR");
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_gebkr_fill_waterState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.pruefprogramm_gebkr_fill_waterState != 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_gebkr_fill_waterStart;
				Programs.pruefprogramm_gebkr_fill_waterStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_gebkr_fill_waterState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static pruefprogramm_gebkr_fill_brainStart: number;
	static pruefprogramm_gebkr_fill_brainRuns = 0;
	static pruefprogramm_gebkr_fill_brainState = 'stopped';
	static pruefprogramm_gebkr_fill_brain(t: any) {
		Programs.pruefprogramm_gebkr_fill_brainRuns++;
		console.log("Program running: " + Programs.pruefprogramm_gebkr_fill_brainRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_gebkr_fill_brainState == 'stopped') {
			Programs.pruefprogramm_gebkr_fill_brainState = 'running';
			let date = new Date();
			Programs.pruefprogramm_gebkr_fill_brainStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		let valueWalker = Programs.riseValueOvertime(duration, 0, 1.5, (n: number) => n.toFixed(1));
		t.getText = function (idx: number) {
			this.value = valueWalker()
			t.title = 'P.30 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_ENVIRONMENT_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_gebkr_fill_brainStart;
			if (idx == 0) {
				return "";
				return this.translator.tr('DELIGHT_TEST_PROGRAM_IMMERSION_HEATER_HEATING_MODE_TITLE_SUBLINE_1') + ((diff < 1000) ? '0' : '50');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {



				this.unit = this.translator.tr("AICI_UNIT_BAR");
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_gebkr_fill_brainState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_gebkr_fill_brainStart;
				Programs.pruefprogramm_gebkr_fill_brainStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_gebkr_fill_brainState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static pruefprogramm_umwkr_fill_brainStart: number;
	static pruefprogramm_umwkr_fill_brainRuns = 0;
	static pruefprogramm_umwkr_fill_brainState = 'stopped';
	static pruefprogramm_umwkr_fill_brain(t: any) {
		Programs.pruefprogramm_umwkr_fill_brainRuns++;
		console.log("Program running: " + Programs.pruefprogramm_umwkr_fill_brainRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_umwkr_fill_brainState == 'stopped') {
			Programs.pruefprogramm_umwkr_fill_brainState = 'running';
			let date = new Date();
			Programs.pruefprogramm_umwkr_fill_brainStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		let valueWalker = Programs.riseValueOvertime(duration, 0, 1.5, (n: number) => n.toFixed(1));
		t.getText = function (idx: number) {
			this.value = valueWalker();
			t.title = 'P.30 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_ENVIRONMENT_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_umwkr_fill_brainStart;
			if (idx == 0) {
				return "";
				return this.translator.tr('DELIGHT_TEST_PROGRAM_IMMERSION_HEATER_HEATING_MODE_TITLE_SUBLINE_1') + ((diff < 1000) ? '0' : '50');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {



				this.unit = this.translator.tr("AICI_UNIT_BAR");
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_umwkr_fill_brainState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_umwkr_fill_brainStart;
				Programs.pruefprogramm_umwkr_fill_brainStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_umwkr_fill_brainState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static pruefprogramm_enteisungStart: number;
	static pruefprogramm_enteisungRuns = 0;
	static pruefprogramm_enteisungState = 'stopped';
	static pruefprogramm_enteisung(t: any) {
		Programs.pruefprogramm_enteisungRuns++;
		console.log("Program running: " + Programs.pruefprogramm_enteisungRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_enteisungState == 'stopped') {
			Programs.pruefprogramm_enteisungState = 'running';
			let date = new Date();
			Programs.pruefprogramm_enteisungStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.12 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_DEICING_MODE_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_DEICING_MODE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_enteisungStart;
				this.unit = this.translator.tr("AICI_UNIT_CELSIUS");
				this.value = "35.0";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.pruefprogramm_enteisungState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.pruefprogramm_enteisungState != 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_enteisungStart;
				Programs.pruefprogramm_enteisungStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_enteisungState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static pruefprogramm_gebentlStart: number;
	static pruefprogramm_gebentlRuns = 0;
	static pruefprogramm_gebentlState = 'stopped';
	static pruefprogramm_gebentl(t: any) {
		Programs.pruefprogramm_gebentlRuns++;
		console.log("Program running: " + Programs.pruefprogramm_gebentlRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_gebentlState == 'stopped') {
			Programs.pruefprogramm_gebentlState = 'running';
			let date = new Date();
			Programs.pruefprogramm_gebentlStart = parseInt("" + date.getTime());
		}

		let duration = 14 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.06 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_BUILDING_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_gebentlStart;

			this.unit = "bar";
			this.value = "1.5";
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_BUILDING_CIRCUIT_DESCRIPTION');
			}

			if (idx == 1) {
				let lastSecond = duration - 1000;
				if (diff < lastSecond) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}
				if (diff > lastSecond) {
					Programs.pruefprogramm_gebentlState = 'stopped';
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

			}

			if (idx == 2) {
				if (diff < duration - 6000) {
					return this.translator.tr('DELIGHT_SPECIAL_FUNCTION_DASHBOARD_CANCEL');
				}
			}

			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.pruefprogramm_gebentlState !== 'stopped') {
				return;
			}
			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_gebentlStart;
				Programs.pruefprogramm_gebentlStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_gebentlState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static wizard_building_airventStart: number;
	static wizard_building_airventRuns = 0;
	static wizard_building_airventState = 'stopped';
	static wizard_building_airvent(t: any) {
		Programs.wizard_building_airventRuns++;
		console.log("Program running: " + Programs.wizard_building_airventRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		if (Programs.wizard_building_airventState == 'stopped') {
			Programs.wizard_building_airventState = 'running';
			let date = new Date();
			Programs.wizard_building_airventStart = parseInt("" + date.getTime());
		}
		t.value = "1.5";

		t.unit = "bar";
		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			let targetNode = this.menuService.getCurrentNode().getTargetNode();
			t.title = this.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_TITLE');
			this.showIconBar = false;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.wizard_building_airventStart;

			let skipStart = 20 * 1000;
			let skipEnd = 3 * 1000;
			if (diff > skipStart && (duration - diff) > 2 * skipEnd) {

				Programs.wizard_building_airventStart -= (duration - (skipStart + skipEnd));
			}
			if (diff > duration) {
				if (Programs.wizard_building_airventState != 'stopped') {
					Programs.wizard_building_airventState = 'stopped';
					console.log("sending confirm.");
					this.eventHandler('confirm');
				}
			}
			if (idx == 0) {

				return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_BUILDING_CIRCUIT_DESCRIPTION');
			}

			if (idx == 1) {

				if (diff < 3000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');//+"...";
				}

				if (diff > 3000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}
				if (diff > duration + 3000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}
				if (diff >= duration) { // && (diff-1000) <= (duration)){
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');//+"...";
				}


				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');//+"...";
			}
			if (idx == 2) {
				if (diff < duration) {

					return this.translator.tr('DELIGHT_INSTALLER_ASSISTANT_TEST_PROGRAM_BACK_CONTINUE');

				}
			}
			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {

			let targetNode = this.menuService.getCurrentNode().getTargetNode();
			console.debug("event wizard_building_airvent " + evt);
			if (evt === 'question') {
				return;
			}

			if (evt === 'confirm') {
				let now = new Date();
				let diff = parseInt("" + now.getTime()) - Programs.wizard_building_airventStart;

				if (diff < 15 * 60 * 1000 - 6000) {
					return;
				}
				//Programs.wizard_building_airventStart = now.getTime() - 15 * 60 * 1000 + 6000;
				/*
				t.eventHandler = eH;
				t.getText = getText;
				t.getTitle = gT;
				*/

				setTimeout(() => {
					if (Programs.wizard_building_airventState != 'stopped') {
						Programs.wizard_building_airventState = 'stopped';
					}
					console.log("goto");
					this.menuService.goto(targetNode);
				}, 3000);
				return;
			}

			if (evt === "back") {

				let d = new Date();
				let diff = d.getTime() - Programs.wizard_building_airventStart;
				Programs.wizard_building_airventStart -= (duration - diff);
				Programs.wizard_building_airventState = 'stopped';
				t.eventHandler = eH;
				setTimeout(
					() => {

						console.debug("back triggered");
						let backTarget = this.menuService.getCurrentNode().getBackTargetNode();
						if (backTarget !== undefined) {
							this.menuService.goto(backTarget);
						}
						//eH.call(t,'back');
						//eH.call(t,'confirm');
					},
					1500
				);
				return;

			} else {
				eH.call(t, evt);
			}
		}
	}



	static wizard_building_brineventStart: number;
	static wizard_building_brineventRuns = 0;
	static wizard_building_brineventState = 'stopped';
	static wizard_building_brinevent(t: any) {
		Programs.wizard_building_brineventRuns++;
		console.log("Program running: " + Programs.wizard_building_brineventRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.wizard_building_brineventState == 'stopped') {
			Programs.wizard_building_brineventState = 'running';
			let date = new Date();
			Programs.wizard_building_brineventStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = this.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.wizard_building_brineventStart;

			this.unit = "bar";

			if (idx == 0) {

				this.value = "0.5";


				return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_BUILDING_CIRCUIT_DESCRIPTION');

				if (diff > 3000) {
					this.value = "1.0";
				}
				if (diff > 7000) {
					this.value = "1.5";
				}

			}

			if (idx == 1) {

				if (diff > 3000 && diff < 7000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 7000 && diff < duration - 3000) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}
				if (diff > duration - 1000) {
					Programs.wizard_building_brineventState = 'stopped';
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

			}

			if (idx == 2) {
				return '';
			}

			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {

			console.debug("wizard_building_brinevent " + evt);
			if (evt === 'question') {
				return;
			}
			if (evt === 'confirm') {
				if (Programs.wizard_building_brineventState == 'stopped') {
					this.menuService.goto(this.menuService.getCurrentNode().getTargetNode());
				}
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.wizard_building_brineventStart;
				Programs.wizard_building_brineventStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.wizard_building_brineventState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static pruefprogramm_allkrentlStart: number;
	static pruefprogramm_allkrentlRuns = 0;
	static pruefprogramm_allkrentlState = 'stopped';
	static pruefprogramm_allkrentl(t: any) {
		Programs.pruefprogramm_allkrentlRuns++;
		console.log("Program running: " + Programs.pruefprogramm_allkrentlRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_allkrentlState == 'stopped') {
			Programs.pruefprogramm_allkrentlState = 'running';
			let date = new Date();
			Programs.pruefprogramm_allkrentlStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.06 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_CIRCUIT_SELECTION_PURGE_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_allkrentlStart;

			this.unit = "bar";
			this.value = "1.5";
			if (idx == 0) {

				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');;
				/*
				if (diff > 1000 && diff < 2000) {
					
				}
				if (diff > 2000 && diff < 3000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_BUILDING_CIRCUIT_BRINE_PRESSURE') + " 1" + this.translator.tr('AICI_UNIT_BAR');
				}
				if (diff > 3000) {
					this.value = "1.0";
				}
				if (diff > 3000 && diff < 4000) {
					return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
				}
				if (diff > 4000 && diff < 7000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_AND_BRINE_BUILDING_CIRCUIT_DESCRIPTION');
				}
				if (diff > 7000) {
					this.value = "1.5";
				}
				if (diff > 7000 && diff < 52000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_BRINE_BUILDING_CIRCUIT_DESCRIPTION');
				}
				if (diff > 52000) {
					this.value = "0.5";
				}
				if (diff > 52000) {
					return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
				}*/
			}

			if (idx == 1) {
				let lastSecond = duration - 1000;
				if (diff > 5000 && diff < lastSecond) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}
				if (diff > lastSecond) {
					Programs.pruefprogramm_allkrentlState = 'stopped';
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

			}

			if (idx == 2) {

				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}

			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {

			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_allkrentlStart;
				Programs.pruefprogramm_allkrentlStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_allkrentlState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}





	static pruefprogramm_zwkrentlStart: number;
	static pruefprogramm_zwkrentlRuns = 0;
	static pruefprogramm_zwkrentlState = 'stopped';
	static pruefprogramm_zwkrentl(t: any) {
		Programs.pruefprogramm_zwkrentlRuns++;
		console.log("Program running: " + Programs.pruefprogramm_zwkrentlRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_zwkrentlState == 'stopped') {
			Programs.pruefprogramm_zwkrentlState = 'running';
			let date = new Date();
			Programs.pruefprogramm_zwkrentlStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_BRINE_BUILDING_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_zwkrentlStart;

			this.unit = "bar";
			this.value = "1.5";
			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
			}

			if (idx == 1) {
				let lastSecond = duration - 1000;
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}
				if (diff > lastSecond) {
					Programs.pruefprogramm_zwkrentlState = 'stopped';
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

			}

			if (idx == 2) {

				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}

			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {

			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_zwkrentlStart;
				Programs.pruefprogramm_zwkrentlStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_zwkrentlState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}









	static pruefprogramm_umwkrentlStart: number;
	static pruefprogramm_umwkrentlRuns = 0;
	static pruefprogramm_umwkrentlState = 'stopped';
	static pruefprogramm_umwkrentl(t: any) {
		Programs.pruefprogramm_umwkrentlRuns++;
		console.log("Program running: " + Programs.pruefprogramm_umwkrentlRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.pruefprogramm_umwkrentlState == 'stopped') {
			Programs.pruefprogramm_umwkrentlState = 'running';
			let date = new Date();
			Programs.pruefprogramm_umwkrentlStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;
		t.getText = function (idx: number) {
			t.title = this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_BUILDING_CIRCUIT_TITLE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.pruefprogramm_umwkrentlStart;
			this.value = "1.5";
			this.unit = "bar";

			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
				/*
				this.value = "0.5";

				if (diff > 1000 && diff < 2000) {
					
				}
				if (diff > 2000 && diff < 3000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_BUILDING_CIRCUIT_BRINE_PRESSURE') + " 1" + this.translator.tr('AICI_UNIT_BAR');
				}
				if (diff > 3000) {
					this.value = "1.0";
				}
				if (diff > 3000 && diff < 4000) {
					return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
				}
				if (diff > 4000 && diff < 7000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_WATER_AND_BRINE_BUILDING_CIRCUIT_DESCRIPTION');
				}
				if (diff > 7000) {
					this.value = "1.5";
				}
				if (diff > 7000 && diff < 52000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PURGE_BRINE_BUILDING_CIRCUIT_DESCRIPTION');
				}
				if (diff > 52000) {
					this.value = "0.5";
				}
				if (diff > 52000) {
					return this.translator.tr('DELIGHT_ACTUATOR_TEST_BUILDING_CIRCUIT_PUMP_DESCRIPTION');
				}*/
			}

			if (idx == 1) {
				let lastSecond = duration - 1000;
				if (diff > 500 && diff < lastSecond) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}
				if (diff > lastSecond) {
					Programs.pruefprogramm_umwkrentlState = 'stopped';
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

			}

			if (idx == 2) {

				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}

			return getText.call(t, idx);

		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.pruefprogramm_umwkrentlStart;
				Programs.pruefprogramm_umwkrentlStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.pruefprogramm_umwkrentlState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}





	static FillWaterProgramStart: number;
	static FillWaterProgramRuns = 0;
	static FillWaterProgramState = 'stopped';
	static FillWaterProgram(t: any) {
		Programs.FillWaterProgramRuns++;
		console.log("Program running: " + Programs.FillWaterProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.FillWaterProgramState == 'stopped') {
			Programs.FillWaterProgramState = 'running';
			let date = new Date();
			Programs.FillWaterProgramStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.08 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.FillWaterProgramStart;
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER_DESCRIPTION');
			}
			if (idx == 2) {
				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}
			if (idx == 1) {

				this.unit = "bar";
				this.value = "1.2";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.FillWaterProgramState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.FillWaterProgramStart;
				Programs.FillWaterProgramStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.FillWaterProgramState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static AdjustableLoadProgramStart: number;
	static AdjustableLoadProgramRuns = 0;
	static AdjustableLoadProgramState = 'stopped';
	static AdjustableLoadProgram(t: any) {
		Programs.AdjustableLoadProgramRuns++;
		console.log("Program running: " + Programs.AdjustableLoadProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.AdjustableLoadProgramState == 'stopped') {
			Programs.AdjustableLoadProgramState = 'running';
			let date = new Date();
			Programs.AdjustableLoadProgramStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.01 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('adjustablePowerLoad')
			this.value = scale.getCurrentValue();
			this.unit = scale.getUnit();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.AdjustableLoadProgramStart;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.AdjustableLoadProgramState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.AdjustableLoadProgramState != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.AdjustableLoadProgramStart;
				Programs.AdjustableLoadProgramStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.AdjustableLoadProgramState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static MaxEingestBelastungProgrammStart: number;
	static MaxEingestBelastungProgrammRuns = 0;
	static MaxEingestBelastungProgrammState = 'stopped';
	static MaxEingestBelastungProgramm(t: any) {
		Programs.MaxEingestBelastungProgrammRuns++;
		console.log("Program running: " + Programs.MaxEingestBelastungProgrammRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.MaxEingestBelastungProgrammState == 'stopped') {
			Programs.MaxEingestBelastungProgrammState = 'running';
			let date = new Date();
			Programs.MaxEingestBelastungProgrammStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.03 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('maxHeatLoad');
			this.value = scale.getCurrentValue();
			this.unit = scale.getUnit();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.MaxEingestBelastungProgrammStart;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.MaxEingestBelastungProgrammState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.MaxEingestBelastungProgrammState != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.MaxEingestBelastungProgrammStart;
				Programs.MaxEingestBelastungProgrammStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.MaxEingestBelastungProgrammState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_07Start: number;
	static actuatortest_07Runs = 0;
	static actuatortest_07State = 'stopped';
	static actuatortest_07(t: any) {
		Programs.actuatortest_07Runs++;
		console.log("Program running: " + Programs.actuatortest_07Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_07State == 'stopped') {
			Programs.actuatortest_07State = 'running';
			let date = new Date();
			Programs.actuatortest_07Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.07 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_MIN_MODULATION');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('burnerMinModulation');

			this.value = scale.getCurrentValue();
			if (!this.value) {
				this.value = "0";
			}
			this.unit = scale.getUnit();


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BURNER_ON_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_07Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_07State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_07State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_07Start;
				Programs.actuatortest_07Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_07State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static actuatortest_06Start: number;
	static actuatortest_06Runs = 0;
	static actuatortest_06State = 'stopped';
	static actuatortest_06(t: any) {
		Programs.actuatortest_06Runs++;
		console.log("Program running: " + Programs.actuatortest_06Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_06State == 'stopped') {
			Programs.actuatortest_06State = 'running';
			let date = new Date();
			Programs.actuatortest_06Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.06 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_06Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_06State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_06State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_06Start;
				Programs.actuatortest_06Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_06State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static actuatortest_05Start: number;
	static actuatortest_05Runs = 0;
	static actuatortest_05State = 'stopped';
	static actuatortest_05(t: any) {
		Programs.actuatortest_05Runs++;
		console.log("Program running: " + Programs.actuatortest_05Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_05State == 'stopped') {
			Programs.actuatortest_05State = 'running';
			let date = new Date();
			Programs.actuatortest_05Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.05 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_05Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_05State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_05State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_05Start;
				Programs.actuatortest_05Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_05State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_04Start: number;
	static actuatortest_04Runs = 0;
	static actuatortest_04State = 'stopped';
	static actuatortest_04(t: any) {
		Programs.actuatortest_04Runs++;
		console.log("Program running: " + Programs.actuatortest_04Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_04State == 'stopped') {
			Programs.actuatortest_04State = 'running';
			let date = new Date();
			Programs.actuatortest_04Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.04 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_04Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_04State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_04State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_04Start;
				Programs.actuatortest_04Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_04State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_03Start: number;
	static actuatortest_03Runs = 0;
	static actuatortest_03State = 'stopped';
	static actuatortest_03(t: any) {
		Programs.actuatortest_03Runs++;
		console.log("Program running: " + Programs.actuatortest_03Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		let initialValue = t.ioService.getDeviceInfo().getScale('fanSpeed').getCurrentValue();
		t.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(14);
		if (Programs.actuatortest_03State == 'stopped') {
			Programs.actuatortest_03State = 'running';
			let date = new Date();
			Programs.actuatortest_03Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.03 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('fanSpeed');

			this.value = scale.getCurrentElement();
			if (!this.value) {
				this.value = "0";
			}
			this.unit = scale.getUnit();


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_03Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_03State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.actuatortest_03State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === 'up' || evt == 'panup') {
				this.ioService.getDeviceInfo().getScale('fanSpeed').increase(true);
				return;
			}
			if (evt === 'down' || evt == 'pandown') {
				this.ioService.getDeviceInfo().getScale('fanSpeed').decrease(true);
				return;
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_03Start;
				Programs.actuatortest_03Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_03State = 'stopped';
						eH.call(t, 'back');
						this.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(initialValue);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static actuatortest_02Start: number;
	static actuatortest_02Runs = 0;
	static actuatortest_02State = 'stopped';
	static acutator_02Sensor = new BaseSensor().setList(['DELIGHT_DIA_CODE_ID_058_VALUE_5', ...(new Array<string>(95).fill('').map((x, i) => (i + 5).toString()))])
	static actuatortest_02(t: any) {
		Programs.actuatortest_02Runs++;
		console.log("Program running: " + Programs.actuatortest_02Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_02State == 'stopped') {
			Programs.actuatortest_02State = 'running';
			let date = new Date();
			Programs.actuatortest_02Start = parseInt("" + date.getTime());
		}
		Programs.acutator_02Sensor.setCurrentValue(0);
		let initialValue = t.ioService.getDeviceInfo().getScale('threewayValveState').getCurrentValue();
		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.01 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.ioService.getDeviceInfo().getScale('threewayValveState').toString();

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_02Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_02State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm' && Programs.actuatortest_02State != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === 'up' || evt == 'panup') {
				this.ioService.getDeviceInfo().getScale('threewayValveState').increase(true);
				return;
			}
			if (evt === 'down' || evt == 'pandown') {
				this.ioService.getDeviceInfo().getScale('threewayValveState').decrease(true);
				return;
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_02Start;
				Programs.actuatortest_02Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_02State = 'stopped';
						eH.call(t, 'back');
						this.ioService.getDeviceInfo().getScale('threewayValveState').setCurrentValue(initialValue);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}





	static hydraulicBalanceStart: number;
	static hydraulicBalanceRuns = 0;
	static hydraulicBalanceState = 'stopped';
	static hydraulicBalance(t: any) {
		Programs.hydraulicBalanceRuns++;
		console.log("Program running: " + Programs.hydraulicBalanceRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.hydraulicBalanceState == 'stopped') {
			Programs.hydraulicBalanceState = 'running';
			let date = new Date();
			Programs.hydraulicBalanceStart = parseInt("" + date.getTime());
		}

		let duration = 6 * 60 * 1000;
		t.getText = function (idx: number) {

			this.dashIcon = 'iconMobile';
			this.menuIcon = 'iconInstallerGrey';
			this.value = "";
			this.unit = "";


			if (idx == 2) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.hydraulicBalanceStart;

				if (diff <= 1000) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
				}
				Programs.hydraulicBalanceState = 'stopped';
				//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {

			if (evt == 'confirm' && Programs.hydraulicBalanceState != 'stopped') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.hydraulicBalanceStart;
				Programs.hydraulicBalanceStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.hydraulicBalanceState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}









	static WaterFillStart: number;
	static WaterFillRuns = 0;
	static WaterFillState = 'stopped';
	static WaterFill(t: any) {
		Programs.WaterFillRuns++;
		console.log("Program running: " + Programs.WaterFillRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.WaterFillState == 'stopped') {
			Programs.WaterFillState = 'running';
			let date = new Date();
			Programs.WaterFillStart = parseInt("" + date.getTime());
		}

		let duration = 5 * 1000;
		t.getText = function (idx: number) {
			if (idx == 0) {
				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.WaterFillStart;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > duration) {
					this.node.addButton('confirm');
					Programs.WaterFillState = 'done';
					return this.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_EXPLANATION');
				}

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm') {
				if (Programs.WaterFillState == 'done') {
					Programs.WaterFillState = 'terminating';
					t.getText = function (idx: number) {
						return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					setTimeout(
						() => {
							Programs.WaterFillState = 'stopped';
							t.eventHandler = eH;
							t.getText = getText;
							this.node.removeButton('confirm');
							let target = this.node.getTargetNode();
							if (target) {
								this.menuService.goto(target);
								return;
							}
						}, 3000);
					return;
				}
				if (Programs.WaterFillState == 'terminating') {
					t.getText = (idx) => {
						return this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					return;
				}
				if (Programs.WaterFillState == 'stopped') {

				}
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.WaterFillStart;
				Programs.WaterFillStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.WaterFillState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}








	static qrCodeStart: number;
	static qrCodeRuns = 0;
	static qrCodeState = 'stopped';
	static qrCode(t: any) {
		Programs.qrCodeRuns++;
		console.log("Program running: " + Programs.qrCodeRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.qrCodeState == 'stopped') {
			Programs.qrCodeState = 'running';
			let date = new Date();
			Programs.qrCodeStart = parseInt("" + date.getTime());
		}

		let duration = 60 * 1000;

		t.getText = function (idx: number) {
			this.menuIcon = 'qrCode';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.qrCodeStart;
			if (diff > duration) {
				Programs.qrCodeState = 'done';
				eH.call(t, 'back');
			}

			if (idx == 0) {
				return "";

			}
			if (idx == 2) {
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			} else {
				return getText.call(t, idx);
			}

		}
		t.eventHandler = function (evt) {

			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.qrCodeStart;
				//Programs.qrCodeStart -= (duration - diff);

				setTimeout(
					() => {
						Programs.qrCodeState = 'stopped';
						eH.call(t, 'back');
						t.eventHandler = eH;
					},
					500
				);
				return;
			} else {
				eH.call(t, evt);
			}
		}
	}




	static ueberstromventilerkennungStart: number;
	static ueberstromventilerkennungRuns = 0;
	static ueberstromventilerkennungState = 'stopped';
	static ueberstromventilerkennung(t: any) {
		Programs.ueberstromventilerkennungRuns++;
		console.log("Program running: " + Programs.ueberstromventilerkennungRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.ueberstromventilerkennungState == 'stopped') {
			Programs.ueberstromventilerkennungState = 'running';
			let date = new Date();
			Programs.ueberstromventilerkennungStart = parseInt("" + date.getTime());
		}
		t.menuService.disableButton('confirm');
		let duration = 2 * 60 * 1000 + 20 * 1000;
		t.getText = function (idx: number) {
			if (Programs.ueberstromventilerkennungState == 'stopped') {
				return '';
			}

			t.title = this.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_TITLE');
			t.subtitle = this.translator.tr('DELIGHT_TEST_PROGRAM_HYDRAULIC_BALANCING_TITLE');
			this.showIconBar = false;
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.ueberstromventilerkennungStart;
			// vergangene sekunden: diff
			// sekunden bis ende: duration - diff
			let skipStart = 5 * 1000;
			let skipEnd = 3 * 1000;
			if (diff > skipStart && (duration - diff) > 2 * skipEnd) {
				Programs.ueberstromventilerkennungStart -= (duration - (skipStart + skipEnd));
			}
			if (diff >= duration) {
			}
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_HYDRAULIC_BALANCING_DESCRIPTION');
			}
			if (idx == 2) {
				return '';
			}
			if (idx == 1) {
				if (diff >= duration + 1000) {
					t.menuService.enableAllButtons();
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');
				}

				if (diff >= duration) {

					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
				}

				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			}

			return '';

		}
		t.eventHandler = function (evt) {
			let duration = 2 * 60 * 1000;
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.ueberstromventilerkennungStart;
			if (diff >= duration + 1000) {

				if (evt === 'confirm') {
					Programs.ueberstromventilerkennungState = 'stopped';
					setTimeout(
						() => eH.call(t, evt),
						150
					);
				}

			}

		}
	}





}
